var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"container",attrs:{"name":"list","tag":"div"}},_vm._l((_vm.collection),function(each){return _c('div',{key:each.id,staticClass:"row"},[_c('NotificationChild',{attrs:{"item":each}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf2ff9f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/app_notification/components/layout.vue
// module id = tQY2
// module chunks = 1